import React from 'react';

import { PhotosScreen } from '~/components/domain/photos/PhotosScreen';

export default function LikedPhotos() {
  return <PhotosScreen listType="favorites" />;
}
